import { render, staticRenderFns } from "./dialog-add-assetTransfer.vue?vue&type=template&id=391e5482&scoped=true&"
import script from "./dialog-add-assetTransfer.vue?vue&type=script&lang=js&"
export * from "./dialog-add-assetTransfer.vue?vue&type=script&lang=js&"
import style0 from "./dialog-add-assetTransfer.vue?vue&type=style&index=0&id=391e5482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391e5482",
  null
  
)

export default component.exports